import { createAsyncThunk } from '@reduxjs/toolkit'
import { openSuccessToaster } from 'helpers/toaster.helpers'
import { generateCryptoPaymentTokenService, generatePaymentTokenService, initiateCryptoWithdrawalService, wallet88EmtService, wallet88PaymentService, getMeshPayLinkTokenService, notifyMeshTransferService } from 'network/services/payment.service'
import { setShowCashierPopup } from 'redux-thunk/redux/slices/settings.slice'

export const generatePaymentToken = createAsyncThunk(
  'post/generate-payment-token',
  async (data, thunkApi) => {
    try {
      const res = await generatePaymentTokenService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const initiateWithdrawRequest = createAsyncThunk(
  'post/initiate-withdraw',
  async (data, thunkApi) => {
    try {
      const res = await generatePaymentTokenService(data)
      openSuccessToaster({ message: 'Withdraw request initiated' })
      thunkApi?.dispatch(setShowCashierPopup(false))
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const generateCryptoPaymentToken = createAsyncThunk(
  'post/generate-crypto-payment-token',
  async (data, thunkApi) => {
    try {
      const res = await generateCryptoPaymentTokenService(data)
      if (res?.widgetUrl) {
        window.open(res.widgetUrl, '_blank')
      }
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)


export const initiateCryptoWithdrawal = createAsyncThunk(
  'post/initiate-crypto-withdrawal',
  async (data, thunkApi) => {
    try {
      const res = await initiateCryptoWithdrawalService(data)

      if (res?.widgetUrl) {
        window.open(res.widgetUrl, '_blank')
      }
      console.error('withdrawal res',res)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error?.[0]?.description || 'Withdrawal Failed')
    }
  }
)


export const bankTransfer = createAsyncThunk(
  'post/wallet88-payment-bank-transfer',
  async (data, thunkApi) => {
    try {
      const res = await wallet88PaymentService(data)
      const blob = new Blob([res.data.data.content], { type: 'text/html' })
      const url = window.URL.createObjectURL(blob)
      window.open(url, '_blank')
      thunkApi?.dispatch(setShowCashierPopup(false))
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const intiEmtWallet88 = createAsyncThunk(
  'post/wallet88-payment-EMT',
  async (data, thunkApi) => {
    try {
      const res = await wallet88EmtService(data)
      thunkApi?.dispatch(setShowCashierPopup(false))
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const getMeshPayLinkToken = createAsyncThunk(
  'post/get-meshpay-link-token',
  async (data, thunkApi) => {
    try {
      const res = await getMeshPayLinkTokenService(data)
      return res?.data || res
    } catch (error) {
      return thunkApi.rejectWithValue(error?.[0]?.description || 'Failed to get MeshPay link token')
    }
  }
)

export const notifyMeshPayTransfer = createAsyncThunk(
  'post/notify-meshpay-transfer',
  async (data, thunkApi) => {
    try {
      const res = await notifyMeshTransferService(data)
      openSuccessToaster({ message: 'Deposit processed successfully!' })
      return res?.data || res
    } catch (error) {
      return thunkApi.rejectWithValue(error?.[0]?.description || 'Failed to process transfer')
    }
  }
)
